import { Box, Stack } from "@mui/material";
import { UserAndRoleAdministrationUser } from "../../../../services/user-role-administration-service/Models";

import type { JSX } from "react";

export type UserTitleProps = {
    user: UserAndRoleAdministrationUser;
};

export default function UserTitle({
    user
}: UserTitleProps): JSX.Element {
    return (
        <Stack direction="row">
            <Box
                sx={{
                    display: "flex",
                    flex: "1 1 auto"
                }}>
                {((user.lastName?.length ?? 0) > 0 || (user.firstName?.length ?? 0) > 0) &&
                    `${user.lastName}, ${user.firstName}`
                }
            </Box>
            <Box>
                {user.login}
            </Box>
        </Stack>
    );
}
